import React from 'react';
import './Hero.css';

function Hero() {
  const handleScroll = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="hero-section" id="home">
      <div className="hero-grid-bg" />
      <div className="hero-glow" />

      <div className="container position-relative">
        <div className="row align-items-center min-vh-85">
          <div className="col-lg-7 col-xl-6">
            <div className="hero-badge fade-in-up">
              <i className="bi bi-geo-alt-fill me-2"></i>
              Serving Across India — Industrial & Commercial
            </div>

            <h1 className="hero-title fade-in-up delay-1">
              Precision<br />
              <span className="hero-accent">Climate Control</span><br />
              Solutions
            </h1>

            <p className="hero-desc fade-in-up delay-2">
              Comprehensive solutions in Dehumidification, Humidification, HVAC,
              Cleanrooms &amp; Dry Rooms — backed by decades of technical expertise
              and a customer-first approach.
            </p>

            <div className="hero-tags fade-in-up delay-3">
              {['Dehumidification', 'HVAC', 'Cleanrooms', 'Dry Rooms', 'AHU'].map(tag => (
                <span key={tag} className="hero-tag">{tag}</span>
              ))}
            </div>

            <div className="d-flex gap-3 flex-wrap fade-in-up delay-4">
              <a href="#services" className="btn-ats-primary" onClick={e => handleScroll(e, '#services')}>
                <i className="bi bi-tools me-2"></i>Our Services
              </a>
              <a href="#contact" className="btn-ats-outline" onClick={e => handleScroll(e, '#contact')}>
                <i className="bi bi-telephone me-2"></i>Contact Us
              </a>
            </div>
          </div>

          <div className="col-lg-5 col-xl-6 d-none d-lg-flex justify-content-center">
            <div className="hero-visual fade-in-up delay-2">
              <div className="hero-circle-outer">
                <div className="hero-circle-mid">
                  <div className="hero-circle-inner">
                    <i className="bi bi-wind hero-main-icon"></i>
                     {/* <img src="/ATS.jpeg" alt="ATS Logo" className="nav-logo" /> */}
                  </div>
                </div>
              </div>
              <div className="hero-orbit orbit-1">
                <div className="orbit-dot"><i className="bi bi-thermometer-half"></i></div>
              </div>
              <div className="hero-orbit orbit-2">
                <div className="orbit-dot"><i className="bi bi-droplet-half"></i></div>
              </div>
              <div className="hero-orbit orbit-3">
                <div className="orbit-dot"><i className="bi bi-fan"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Wave divider */}
      <div className="hero-wave">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z" fill="#0d1b2a" />
        </svg>
      </div>
    </section>
  );
}

export default Hero;
